import React, { useState } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCheck,
  faCopy,
  faPenToSquare,
  faRefresh,
} from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import copy from 'copy-to-clipboard'

import { ConfirmModal, AlertModal } from './Modal'

function CustomerOrderStatus(props) {
  const customer = props.customer
  const isOpen = !!customer.enabled
  const [copied, setCopied] = useState(null) // 'single' | 'producer' | null
  const [pendingAction, setPendingAction] = useState(null)
  const [errorMessage, setErrorMessage] = useState('')

  function flashCopied(kind) {
    setCopied(kind)
    setTimeout(() => setCopied(c => (c === kind ? null : c)), 1400)
  }
  function copyLink(kind) {
    const id = kind === 'single' ? customer.singleId : customer.producerId
    if (!id) {
      setErrorMessage(
        `Manca il link ${kind}. Rigenera gli ID prima di copiarlo.`,
      )
      return
    }
    copy('https://app.cutcatering.it/order/' + id)
    flashCopied(kind)
  }

  async function performRegenerate() {
    try {
      const resp = await fetch(
        'https://app.cutcatering.it/api/customers/' +
          customer._id +
          '/renewIds',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-auth-token': localStorage.getItem('cut-catering-token'),
          },
        },
      )
      if (!resp.ok) {
        setErrorMessage('Rigenerazione fallita.')
        return
      }
      const result = await resp.text()
      props.setChange?.(result)
    } catch (e) {
      setErrorMessage('Errore di rete. Riprova.')
    }
  }

  async function performToggle() {
    try {
      const resp = await fetch(
        'https://app.cutcatering.it/api/customers/' + customer._id,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-auth-token': localStorage.getItem('cut-catering-token'),
          },
          body: JSON.stringify({ enabled: !isOpen }),
        },
      )
      if (!resp.ok) {
        setErrorMessage('Cambio stato fallito.')
        return
      }
      const result = await resp.text()
      props.setChange?.(result)
    } catch (e) {
      setErrorMessage('Errore di rete. Riprova.')
    }
  }

  const askRegenerate = () =>
    setPendingAction({
      title: 'Rigenerare i link Single e Producer?',
      message:
        'I link attuali smetteranno di funzionare immediatamente: chiunque ne avesse copia (chat, PDF stampati, segnalibri) non potrà più accedere alla pagina ordine. Ne otterrai due nuovi.',
      confirmLabel: 'Sì, rigenera',
      run: performRegenerate,
    })

  return (
    <div className={`customer-row${isOpen ? '' : ' customer-row-disabled'}`}>
      <div className="customer-info">
        <p className="customer-name">{customer.name || 'Cliente'}</p>
        <div className="customer-meta">
          <span
            className={`customer-meta-pill ${
              isOpen ? 'customer-meta-pill-open' : 'customer-meta-pill-closed'
            }`}
          >
            {isOpen ? 'Aperto' : 'Chiuso'}
          </span>
          <span>{customer.orders || 0} porzioni</span>
        </div>
      </div>

      <div className="customer-actions">
        <button
          type="button"
          className={`btn-action btn-action-secondary${
            copied === 'single' ? ' btn-action-copied' : ''
          }`}
          onClick={() => copyLink('single')}
          title="Copia link Single"
        >
          <FontAwesomeIcon icon={copied === 'single' ? faCheck : faCopy} />{' '}
          {copied === 'single' ? 'Copiato!' : 'Single'}
        </button>
        <button
          type="button"
          className={`btn-action btn-action-secondary${
            copied === 'producer' ? ' btn-action-copied' : ''
          }`}
          onClick={() => copyLink('producer')}
          title="Copia link Producer"
        >
          <FontAwesomeIcon icon={copied === 'producer' ? faCheck : faCopy} />{' '}
          {copied === 'producer' ? 'Copiato!' : 'Producer'}
        </button>
        <button
          type="button"
          className="btn-action btn-action-warning"
          onClick={askRegenerate}
          title="Rigenera link (i vecchi smettono di funzionare)"
        >
          <FontAwesomeIcon icon={faRefresh} /> Rigenera
        </button>
        <button
          type="button"
          className={`btn-action ${
            isOpen ? 'btn-action-secondary' : 'btn-action-primary'
          }`}
          onClick={performToggle}
        >
          {isOpen ? 'Chiudi ordini' : 'Apri ordini'}
        </button>
        <span className="customer-actions-divider" aria-hidden="true" />
        <Link
          to={`/customers/${customer._id}`}
          className="btn-action btn-action-icon"
          title="Modifica cliente"
        >
          <FontAwesomeIcon icon={faPenToSquare} />
        </Link>
      </div>

      <ConfirmModal
        open={!!pendingAction}
        title={pendingAction?.title}
        message={pendingAction?.message}
        confirmLabel={pendingAction?.confirmLabel}
        danger
        onConfirm={() => {
          const action = pendingAction
          setPendingAction(null)
          if (action) action.run()
        }}
        onCancel={() => setPendingAction(null)}
      />
      <AlertModal
        open={!!errorMessage}
        title="Operazione non riuscita"
        message={errorMessage}
        onClose={() => setErrorMessage('')}
      />
    </div>
  )
}

export default CustomerOrderStatus
